import { ReactNode } from "react";
import { FieldValues, useController, UseControllerProps } from "react-hook-form";

import EditableMarkdownText, {
  EditableMarkdownTextProps,
} from "components/ui/editable_markdown_text/EditableMarkdownText";

import css from "./Inputs.module.scss";

type EditableMarkdownProps<T extends FieldValues> = UseControllerProps<T> & {
  label: ReactNode;
  subLabel?: string;
  required?: boolean;
  placeholder?: string;
  disabled?: boolean;
  autoSize?: EditableMarkdownTextProps["autoSize"];
  maxHeight?: EditableMarkdownTextProps["maxHeight"];
  minHeight?: EditableMarkdownTextProps["minHeight"];
  bordered?: EditableMarkdownTextProps["bordered"];
  customComponents?: EditableMarkdownTextProps["customComponents"];
};

export function EditableMarkdown<T extends FieldValues>(props: EditableMarkdownProps<T>) {
  const {
    label,
    subLabel,
    required,
    placeholder,
    disabled,
    autoSize,
    maxHeight,
    minHeight,
    bordered,
    customComponents,
  } = props;
  const { field, fieldState } = useController(props);

  return (
    <div>
      <label htmlFor={props.name} className={css.label}>
        <h3>
          {required && <span className={css.required}>*</span>}
          {label}
        </h3>
        {subLabel && <span className={css.subLabel}>{subLabel}</span>}
      </label>

      <EditableMarkdownText
        initialValue={field.value ?? ""}
        placeholder={placeholder}
        onSave={field.onChange}
        hasEditAccess={!disabled}
        autoSize={autoSize}
        maxHeight={maxHeight}
        minHeight={minHeight}
        bordered={bordered}
        customComponents={customComponents}
      />

      {fieldState.error?.message && (
        <span className={css.errorMessage}>{fieldState.error.message}</span>
      )}
    </div>
  );
}
